import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'lib-searchable-mat-menu',
  templateUrl: './searchable-mat-menu.component.html',
  styleUrl: './searchable-mat-menu.component.scss'
})
export class SearchableMatMenuComponent implements OnChanges,OnInit,OnDestroy {

  @Input() items: any[] = []; 
  @Input() displayProperty: string = ''; 
  @Input() filterProperty: string = ''; 
  @Input() menuButtonLabel: string = 'add'; 
  @Output() itemSelected = new EventEmitter<any>(); 

  searchQuery: string = '';
  filteredItems: { item: any; displayValue: string }[] = []; 

  ngOnInit() {
    this.updateFilteredItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['items']){
      this.updateFilteredItems();
    }
  }


  filterMenuItems() {
    const query = this.searchQuery.toLowerCase();
    this.filteredItems = this.items
      .filter(item => {
        const filterValue = this.getNestedValue(item, this.filterProperty)?.toLowerCase();
        return filterValue?.includes(query);
      })
      .map(item => ({
        item,
        displayValue: this.getNestedValue(item, this.displayProperty),
      }));
  }

  clearSearch() {
    this.searchQuery = '';
    this.updateFilteredItems();
  }

  updateFilteredItems() {
    this.filteredItems = this.items.map(item => ({
      item,
      displayValue: this.getNestedValue(item, this.displayProperty),
    }));
  }

  onItemClick(item: any,index:number) {
    this.itemSelected.emit({selectedItem:item,selectedIndex:index});
    this.searchQuery = '';
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((o, key) => (o ? o[key] : null), obj);
  }

  ngOnDestroy(): void {
    this.searchQuery = '';
  }
}
